export enum Language {
  English = 'en',
  Dutch = 'nl',
  French = 'fr',
  Spanish = 'es',
  German = 'de',
}

export type SupportedLanguages =
  | Language.English
  | Language.Dutch
  | Language.French
  | Language.Spanish
  | Language.German;

export enum Currency {
  AUD = 'aud',
  EUR = 'eur',
  GBP = 'gbp',
  USD = 'usd',
}

export type SupportedCurrencies =
  | Currency.AUD
  | Currency.EUR
  | Currency.GBP
  | Currency.USD;

export enum Locales {
  UnitedStatesEnglish = 'en-US',
  UnitedKingdomEnglish = 'en-GB',
  AustralianEnglish = 'en-AU',
  // note en-EU is not a valid iso language code. formatters should convert to en-150 for accurate localization.
  // @see {https://www.localeplanet.com/icu/en-150/index.html} for more information
  EuropeanEnglish = 'en-EU',
  StandardSpanish = 'es',
  StandardGerman = 'de',
  StandardFrench = 'fr',
  StandardDutch = 'nl',
}

export type SupportedLocales =
  | Locales.UnitedStatesEnglish
  | Locales.UnitedKingdomEnglish
  | Locales.AustralianEnglish
  | Locales.EuropeanEnglish
  | Locales.StandardSpanish
  | Locales.StandardGerman
  | Locales.StandardFrench
  | Locales.StandardDutch;

export enum Region {
  US = 'US',
  EU = 'EU',
  UK = 'UK',
  AU = 'AU',
}

export type SupportedRegions = Region.US | Region.EU | Region.UK | Region.AU;
